"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var getValueMatchingKey = require('../getValueOfKeyMatching');

function parseResponse(params) {
  var quantity = parseInt(getValueMatchingKey(params, /^responseCards|^lp_responseCards|REPRINT_[lp_]*responseCards/), 10);

  if (quantity > 0) {
    var return_addressing = parseBoolean(getValueMatchingKey(params, /^response_returnAddressing|^lp_response_returnAddressing|REPRINT[lp_]*_res_returnAddressing/), 10);
    var returnAddress = getValueMatchingKey(params, /^pers_[lp_]*response_returnAddressing/);
    var pers = getValueMatchingKey(params, /^pers_[lp_]*responseCards/);

    if (pers) {
      this.personalization.push({
        name: 'Response Cards',
        value: pers
      });
    }

    if (params.responseCards || params.REPRINT_responseCards || params.COVID_REPRINT_responseCards) {
      this.responseCards.add({
        quantity: quantity
      });
    }

    if (params.lp_responseCards || params.REPRINT_lp_responseCards || params.COVID_REPRINT_lp_responseCards) {
      this.letterpressResponseCards.add({
        quantity: quantity
      });
    }

    if (returnAddress) {
      this.personalization.push({
        name: 'Response Return Address',
        value: returnAddress
      });
    }

    this.responseCardEnvelopes.add({
      quantity: quantity,
      return_addressing: return_addressing
    });
  }
}

module.exports = parseResponse;